import styled from 'styled-components';

import { Divider } from '@components/Divider';
import { useModalContext } from '@providers/ModalProvider';
import { ModalNamesEnum } from '@constants/enums/ModalNamesEnum';
import { TBillingAccount } from 'app/types/entities/TBillingAccount';

const Wrapper = styled.div`
  width: 230px;
  min-height: 220px;
  background: transparent;
  border-radius: 10px;
  border: 1px solid #d5def2;
  padding: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  cursor: pointer;

  :hover {
    border: 1px solid #858dbd;
    .button {
      text-decoration: underline;
    }
  }

  .divider {
    margin: 10px 0;
  }

  .title {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 150%;
    text-transform: capitalize;
    color: #858dbd;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .text {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    color: #878787;
  }

  .button {
    color: #7cb1fe;
    font-weight: 500;
    font-size: 16px;
    line-height: 34px;
    text-align: center;
    text-decoration: none;
    text-decoration-style: solid;
    height: 40px;
    width: calc(100% - 40px);
    margin: 0;
    display: block;
    bottom: 0;
    position: absolute;
    border-top: 1px solid #d5ddf2;
  }
`;

type TProps = {
  billingAccount: TBillingAccount;
  onSuccess?: () => void;
};

export type PlanSelection = {
  subscriptionProductId: string;
  planName: string;
  price: number;
  freeSeats: number;
};

export const AddSubscription = ({ billingAccount, onSuccess }: TProps) => {
  const { openModal, closeModal } = useModalContext();

  const onClick = () => {
    openModal(ModalNamesEnum.ChooseASOneSubscriptionModal, {
      billingAccountId: billingAccount.id,
      onSuccess: ({ subscriptionProductId, planName, price, freeSeats }: PlanSelection) => {
        closeModal();
        if (onSuccess) {
          onSuccess();

          openModal(ModalNamesEnum.ConfirmSubscription, {
            billingAccountId: billingAccount.id,
            subscriptionProductId,
            planName,
            freeSeats,
            onSuccess,
            price: Number(price),
          });
        }
      },
    });
  };

  if (billingAccount.subscriptions?.length) {
    return null;
    // return (
    //   <Wrapper onClick={onClick}>
    //     <div className="title">Upgrade</div>
    //     <Divider className="divider" />
    //     <div className="text">Expand your access: add subscription to your account</div>
    //   </Wrapper>
    // );
  }

  return (
    <Wrapper onClick={onClick}>
      <div className="title">AutoScript One</div>
      <Divider className="divider" />
      <div className="text">RealTime Reporter Capture Tool (BETA)</div>
      <div className="button">+ Add Subscription</div>
    </Wrapper>
  );
};
